import { createContext, useContext } from 'react';

interface IDelayedRendererContext {
  canRenderComponent: boolean;
}

const initialValue: IDelayedRendererContext = {
  canRenderComponent: false,
};

const DelayedRendererContext = createContext(initialValue);

export const useDelayedRenderContext = () => useContext(DelayedRendererContext);

export default DelayedRendererContext;
